import { type FC, type ReactElement } from "react";
import * as styles from "./styles.css";

type Props = {
  id?: string;
  children: ReactElement[] | ReactElement;
};

export const BoxWithShadow: FC<Props> = ({ id, children }) => (
  <div className={styles.boxWithShadow} id={id}>
    {children}
  </div>
);
